// extracted by mini-css-extract-plugin
module.exports = {"root":"W_bk","full-width":"W_dj","fullWidth":"W_dj"};